import React from "react";

export default function PlansPromoDisclaimer({ promo, pRole }) {
  if (promo && promo.description && promo.planGroups.includes(pRole.toUpperCase())) {
    return <div className="plans-promo-disclaimer">{`*${promo.disclaimer}`}</div>;
  }

  return null;
}
